// extracted by mini-css-extract-plugin
module.exports = {"circle":"src-containers-Events-styles__circle--XOi89","name":"src-containers-Events-styles__name--1DlS0"};